<template>
  <div class="no-results-fi">
    <div
      v-if="subheadline"
      class="no-results-fi__subheadline"
    >
      {{ subheadline }}
    </div>
    <div
      v-if="headline"
      class="no-results-fi__headline"
    >
      {{ headline }}
    </div>
    <img
      :src="noProductSearchResultImg"
      :alt="headline"
      class="no-results-fi__image"
    />
    <button-fi
      v-if="buttonText"
      class="button-fi__primary--large"
      @click="$emit('button-clicked')"
    >
      {{ buttonText }}
    </button-fi>
    <button-fi
      v-else-if="link?.url || link?.href"
      class="button-fi__primary--large"
      :href="link?.url || link?.href"
      natural-events
    >
      {{ link?.text }}
    </button-fi>
  </div>
</template>

<script setup lang="ts">
import ButtonFi from '@/components/atoms/button-fi/ButtonFi.vue';
import { useAssetUrl } from '@/composables/assetUrl';

defineOptions({
  name: 'NoResultsFi',
});

const { getAssetUrl } = useAssetUrl();
const noProductSearchResultImg: string = getAssetUrl(
  '/img/search-suggestions/no-search-results.svg',
);

defineProps<{
  headline?: string;
  subheadline?: string;
  buttonText?: string;
  link?: {
    href?: string;
    url?: string;
    text?: string;
    altText?: string;
  };
}>();

defineEmits<{
  'button-clicked': [value: void];
}>();
</script>

<style scoped src="./no-results-fi" />
